/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GetSpacesSortField = core.serialization.enum_([
    "name",
    "workbooksCount",
    "filesCount",
    "environmentId",
    "createdByUserName",
    "createdAt",
    "lastActivityAt",
]);
